<template>
  <div>
    <div class="wrapper">
      <Header />
      <MenuLocal />

      <Modal v-model="showDelateModal" width="360">
        <p slot="header" style="color:red;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>CONFIRMATION</span>
        </p>
        <div style="text-align:center">
          <p>Etes-vous sûr d'avoir rempli les notes à tous ?</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long @click="Presence">Confirmer</Button>
        </div>
      </Modal>

      <div class="content-wrapper">
        <div class="container-full">
          <section class="content">
            <br />

            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for>Evaluation en cour</label>

                      <select
                        v-model="datas.libelleEvaluation
                                                "
                        class="custom-select form-control required"
                      >
                        <option
                          v-for="(data,
                                                    i) in Evaluation"
                          :key="i"
                          :value="data.id
        "
                        >
                          {{
                          data.libelle
                          }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for>Classe</label>
                      <select
                        @change="onChange($event)"
                        v-model="datas.classeName"
                        class="custom-select form-control required"
                      >
                        <option
                          v-for="(data,
                                                    i) in ClassListes"
                          :key="i"
                          :value="data.id"
                        >{{ data.libelleClasse }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for>Matière</label>

                      <select v-model="datas.matiere" class="custom-select form-control required">
                        <option
                          v-for="(data,
                                                    i) in LIbelleMatiereclasse"
                          :key="i"
                          :value="data.id"
                        >{{ data.libelle }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for>Voulez-vous affecter une note commune à toute la classe ?</label>

                      <select
                        @change="onChangeVal($event)"
                        v-model="datas.commune"
                        class="custom-select form-control required"
                      >
                        <option value="Oui">Oui</option>
                        <option value="Non">Non</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6" v-if="datas.commune=='Oui'">
                    <div class="form-group">
                      <label for>Veillez entrer cette note ici svp...</label>

                      <input type="number" class="form-control" v-model="datas.communeValue" />
                    </div>
                  </div>
                </div>

                <div class="row" v-if="datas.choice==0">
                  <div class="col-md-6">
                    <div class="form-group">
                      <button
                        @click="afficher"
                        class="waves-effect waves-light btn mb-5 btn btn-primary"
                      >Envoyer</button>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="datas.choice==1">
                  <div class="col-md-6">
                    <div class="form-group">
                      <button
                        @click="Annuler"
                        class="waves-effect waves-light btn mb-5 btn btn-danger"
                      >Annuler</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />
            <br />

            <div class="row" v-if="rempli == true">
              <div class="col-12">
                <div class="box">
                  <div class="box-header bg-primary">
                    <h4 class="box-title">Notes</h4>
                  </div>
                  <div class="box-body">
                    <div class="table-responsive">
                      <table id="example" class="table simple mb-0" style="width:100%">
                        <thead>
                          <tr>
                            <th>Number</th>
                            <th>Matricule</th>
                            <th>Noms et Prénoms</th>

                            <th>Notes</th>

                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, i) in Classes" :key="i">
                            <td>
                              <!-- <img
                                width="60"
                                height="40"
                                :src="`/Photos/Logos/${data.user.photo}`
                                                            "
                                alt
                              />-->
                              {{ i + 1 }}
                            </td>
                            <td>{{ data.matricule }}</td>
                            <td>{{ data.nom }} {{ data.prenom }}</td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                :disabled="datas.commune=='Oui'"
                                max="20"
                                class="form-control"
                                v-model="data.valeur"
                              />

                              <!-- <button
                                @click="showEdetingModal(data,i,d)"
                                v-if="data.valeur != null && data.statusNote == null"
                                class="btn btn-primary btn-xs"
                              >
                                {{
                                data.valeur
                                }}
                              </button>-->
                              <!--
                              <button
                                @click="showEdetingModal(data,i,d)"
                                v-if="data.valeur != null && data.statusNote == 1"
                                class="btn btn-primary btn-xs"
                              >
                                <Icon type="md-checkmark" />
                              </button>-->

                              <!-- <button
                                v-if="data.valeur == null"
                                class="btn btn-danger btn-xs"
                              >Aucune note</button>-->
                            </td>

                            <!-- <td>
                              <button
                                v-if="data.valeur != NULL && data.valeur == 0"
                                class="btn btn-success btn-xs"
                                @click="showDelatingModal(data, i)"
                                title="Justifier en cas d'absence"
                              >Justifier</button>

                              <button
                                v-if="data != NULL && data.valeur == 0"
                                class="btn btn-danger btn-xs"
                                @click="showDelatingModal2(data, i)"
                                title="Blamer en cas d'absence"
                              >Blammer</button>
                            </td>-->
                          </tr>

                          <button class="btn btn-primary" @click="saveDatas">
                            <i class="fa-solid fa-download"></i> Enregister Tout ici
                          </button>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="rempli == true">
              <div class="col-md-6">
                <div class="form-group">
                  <button
                    type="button"
                    class="waves-effect waves-light btn mb-5 btn btn-primary"
                    @click="ShowModal"
                  >Enregistrer</button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Chats />
  </div>
</template>

<script>
import Header from "../../headers/Header.vue";
import MenuLocal from "../../navs/MenuLocal.vue";
import Chats from "../../navs/Chats.vue";
import { mapState } from "vuex";
import {
  required,
  minLength,
  alpha,
  email,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";
import { log } from "util";

export default {
  components: { Header, MenuLocal, Chats },
  data() {
    return {
      datas: {
        classeName: "",
        idClasse: "",
        libelleEvaluation: "",
        matiere: "",
        trimestre: "",
        choice: 0,
        commune: "Non",
        communeValue: ""
      },

      Note: {},
      Obser: {},
      i: 1,
      showDelateModal: false,
      LIbelleMatiereclasse: "",
      checkedNames: [],
      checkBoxs: [],
      rempli: false,
      users: [],
      ClassListes: [],
      MatieresListes: [],
      Notes: [],
      Classes: [],
      Evaluation: [],
      show: false
    };
  },

  async mounted() {
    if (!localStorage.users) {
      this.$router.push("login");
    }

    if (localStorage.EtabInfos) {
      this.EtabInfos = JSON.parse(localStorage.getItem("EtabInfos"));
    }

    // Recuperer toutes les sessions de cette ecole

    const response2 = await this.callApi(
      "post",
      "api/locale/getClasseEtablissement",
      this.EtabInfos
    );

    this.ClassListes = response2.data;

    this.ClassListes = this.ClassListes.filter(item => item.eleves.length > 0);

    const response4 = await this.callApi(
      "post",
      "api/teacher/getEvaluationActif",
      this.EtabInfos
    );
    this.Evaluation = response4.data;
  },
  methods: {
    async onChange(event) {
      this.datas.idClasse = event.target.value;

      this.datas.EtabInfos = this.EtabInfos;

      // Recuperer toutes les matieres de cette  classe

      const response3 = await this.callApi(
        "post",
        "api/locale/getLibelleMatiereclasseLocaleById",
        this.datas
      );

      this.LIbelleMatiereclasse = response3.data;
    },

    ShowModal() {
      this.showDelateModal = true;
    },

    async Presence() {
      console.log("Je suis les datas", this.Notes);

      for (var item in this.Notes) {
        let valeur = this.Notes[item]["valeur"];

        this.Notes[item]["Ideval"] = this.datas.libelleEvaluation;
        this.Notes[item]["Idmatiere"] = this.datas.matiere;
        this.Notes[item]["Idtrimestre"] = this.datas.trimestre;
        this.Notes[item]["Idclasse"] = this.datas.idClasse;

        // Vérifie si la valeur n'est pas un nombre (NaN) ou est hors de l'intervalle 0-20
        if (valeur > 20 || valeur < 0) {
          var dec = true;
          this.e(
            " La ligne " +
              (parseInt(item) + 1) +
              " contient une note invalide. Assurez-vous d'entrer un nombre compris entre << 0 et 20 >>."
          );
          break;
        } else {
          dec = false;
        }
      }

      if (dec == false) {
        this.$Spin.show();
        const response = await this.callApi(
          "post",
          "api/teacher/AddNotenewversion",
          this.Notes
        );

        if (response.status == 200) {
          this.$Spin.hide();
          this.s(" Notes  correctement enregistrées");

          // this.$router.push("dashExamenTeacher");
        }

        if (response.status == 401) {
          this.$Spin.hide();
          this.e(
            " Les notes pour cette matière et cette évaluation existent déjà "
          );
        }

        if (response.status == 405) {
          this.$Spin.hide();
          this.e("Les notes doivent être entre 0 et 20");
        }

        if (response.status == 403) {
          this.$Spin.hide();
          this.e("Aucune notes saisies");
        }

        this.$Spin.hide();
      }

      this.$Spin.hide();
    },

    async Annuler() {
      console.log(this.datas);

      if (this.datas.libelleEvaluation == "") {
        return this.e("Sélectionner  une évaluation ");
      }

      if (this.datas.classeName == "") {
        return this.e("Sélectionner  une classe ");
      }

      if (this.datas.matiere == "") {
        return this.e("Sélectionner la matiere");
      }

      const response25 = await this.callApi(
        "post",
        "api/teacher/justifierAll",
        this.datas
      );

      if (response25.status == 200) {
        this.s(" Notes ajoutées correctement");

        // this.$router.push("notes");
      }
    },

    async afficher() {
      console.log(this.datas);

      if (this.datas.libelleEvaluation == "") {
        return this.e("Sélectionner  une évaluation ");
      }

      if (this.datas.classeName == "") {
        return this.e("Sélectionner  une classe ");
      }

      if (this.datas.matiere == "") {
        return this.e("Sélectionner la matiere");
      }

      const response2 = await this.callApi(
        "post",
        "api/teacher/getStudentByTeacherVoirNote",
        this.datas
      );

      this.Classes = response2.data;

      if (this.Classes == "") {
        this.rempli = false;
      } else {
        this.rempli = true;
      }
    }
  }
};
</script>

<style>
.content-wrapper {
  background-color: #fafbfd;
}

.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
